import DeleteIcon from '@mui/icons-material/Delete';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Button, CardMedia, IconButton } from '@mui/material';
import React, { ChangeEvent, useState } from 'react';

interface ImageUploadTicketProps {
  buttonText: string;
  setSelectedImage: React.Dispatch<React.SetStateAction<File | null>>;
  selectedImage: File | null;

  isUpdating?: boolean;
  imageUrl?: string;
  setIsUpdatingCb?: Function;

  enablePreview?: boolean;
  customPrevieContentNode?: React.ReactNode;

  accept?: string;

  onClickTrash?: () => void;

  onRemoveImage?: (imageUrl?: any, selectedImage?: any) => void;
  onChangeImage?: (imageUrl?: any, selectedImage?: any) => void;

  disabledInput?: boolean;

  showCustomPreviewEdit?: boolean;
  customPreviewEditNode?: React.ReactNode;
}

const ImageUploadTicketComponente: React.FC<ImageUploadTicketProps> = ({
  buttonText,
  setSelectedImage,
  selectedImage,

  enablePreview = true,
  customPrevieContentNode,

  imageUrl,

  accept = 'image/*',

  onClickTrash,
  onRemoveImage,
  onChangeImage,

  disabledInput = false,

  showCustomPreviewEdit = false,
  customPreviewEditNode,
}) => {
  const [imagenUrl, setImagenUrl] = useState<string | undefined>(imageUrl);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files && files.length > 0) {
      const selectedFile = files[0];

      setSelectedImage(selectedFile);
    }

    /* const file = event.target.files?.[0];
    if (file && file.type === 'application/pdf') {
      //setPdfFile(URL.createObjectURL(file));
    }

    if (file && file.type.startsWith('image/')) {
      const selectedFile = file;
      setSelectedImage(selectedFile);
    } */
  };

  return (
    <div>
      <input
        type="file"
        accept={accept}
        onChange={e => {
          if (disabledInput) return;

          handleFileChange(e);
          onChangeImage && onChangeImage(imageUrl, selectedImage);
        }}
        style={{ display: 'none' }}
        id={'image-upload-input-' + buttonText}
        disabled={disabledInput}
      />
      <label htmlFor={'image-upload-input-' + buttonText}>
        <Button
          variant="contained"
          component="span"
          fullWidth
          size="small"
          startIcon={<FileUploadIcon />}
          style={{
            padding: '5.5px 14px',
            backgroundColor: 'white',
            border: '1px solid #b8bdc1',
            color: '#747474',
            borderRadius: 7,
            textTransform: 'none',
            fontFamily: 'Helvetica',
            fontWeight: '400',
            fontSize: '1rem',
            justifyContent: 'flex-start',
            minHeight: '54px',
          }}
        >
          {buttonText}
        </Button>
      </label>

      {(selectedImage || imagenUrl) && enablePreview && (
        <>
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            {disabledInput ? null : (
              <IconButton
                aria-label="Eliminar"
                onClick={() => {
                  setSelectedImage(null);
                  setImagenUrl(undefined);

                  onClickTrash && onClickTrash();
                  onRemoveImage && onRemoveImage(imagenUrl, selectedImage);
                }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CardMedia
              component="img"
              alt="Vista Previa"
              sx={{
                maxHeight: 600,
                maxWidth: 300,
                objectFit: 'cover',
              }}
              image={
                selectedImage ? URL.createObjectURL(selectedImage) : imageUrl
              }
            />
          </div>
        </>
      )}

      {!enablePreview && selectedImage && customPrevieContentNode && (
        <>{customPrevieContentNode}</>
      )}

      {showCustomPreviewEdit && customPreviewEditNode && <>{customPreviewEditNode}</>}
    </div>
  );
};

export default ImageUploadTicketComponente;
